import { z } from 'zod';

const envSchema = z.object({
  NODE_ENV: z.enum(['development', 'production', 'test']).default('development'),
  PUBLIC_URL: z.string().optional().default(''),
});

export const env = (customEnv: Record<string, string | undefined> = process.env) => {
  const result = envSchema.safeParse({
    NODE_ENV: customEnv.NODE_ENV,
    PUBLIC_URL: customEnv.PUBLIC_URL,
  });

  if (!result.success) {
    console.error('❌ Invalid environment variables:', result.error.format());
    throw new Error('Invalid environment variables configuration');
  }

  return result.data;
};
